'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Dateevent;
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function Dateevent(_ref) {
  var size = _ref.size,
    strokeColor = _ref.strokeColor,
    strokeWidth = _ref.strokeWidth,
    fillColor = _ref.fillColor,
    svgClass = _ref.svgClass;
  var inlineStyling = {
    fill: fillColor,
    stroke: strokeColor,
    strokeWidth: strokeWidth
  };
  return _react2.default.createElement('svg', {
    className: svgClass,
    height: size,
    style: inlineStyling,
    viewBox: '0 0 24 24',
    width: size,
    xmlns: 'http://www.w3.org/2000/svg'
  }, _react2.default.createElement('path', {
    d: 'M16.4446667,12.9001012 L12.0000001,12.9001012 L12.0000001,17.4002699 L16.4446667,17.4002699 L16.4446667,12.9001012 Z M15.5553334,3 L15.5553334,4.80020248 L8.44466676,4.80020248 L8.44466676,3 L6.66666677,3 L6.66666677,4.80020248 L5.77800011,4.80020248 C4.79133345,4.80020248 4.00866679,5.61019235 4.00866679,6.60040497 L4.00000013,19.1997974 C3.99982319,19.6772957 4.18709084,20.1352883 4.52056888,20.4729306 C4.85404692,20.8105729 5.30639098,21.000179 5.77800011,20.9999999 L18.222,20.9999999 C19.2,20.9999999 20,20.19001 20,19.1997974 L20,6.60040497 C20,5.61019235 19.2,4.80020248 18.222,4.80020248 L17.3333334,4.80020248 L17.3333334,3 L15.5553334,3 Z M18.222,19.1997974 L5.77800011,19.1997974 L5.77800011,9.3003712 L18.222,9.3003712 L18.222,19.1997974 Z'
  }));
}
Dateevent.defaultProps = {
  strokeColor: 'blue',
  strokeWidth: 0,
  fillColor: '#bada55',
  size: 32,
  svgClass: 'sui-SVGicon'
};